import React, { useState, useEffect } from 'react';
import { Button, Card, Text } from 'v3/components';
import Space from 'v3/components/Space';
import { cooperplaceApi } from 'services/api';
import { useSnackbar } from 'v3/components/Snackbar';
import { RegisterComponent } from '../components/RegisterComponents';
import { QuestionSchema } from '../shared/validator';
import {
  canSaveVideoVisualizationQuestion,
  CODE_READER_QUESTION_SLUG,
  IMPLEMENT_PLATE_QUESTION_SLUG,
  VEHICLE_PLATE_QUESTION_SLUG,
  VIDEO_VISUALIZATION_QUESTION_SLUG,
} from '../shared/utils';

const FIXED_QUESTION_TEXT_BY_SLUG = {
  [VEHICLE_PLATE_QUESTION_SLUG]: 'Informe a placa do veículo de tração',
  [IMPLEMENT_PLATE_QUESTION_SLUG]: 'Informe a placa do implemento / carroceria',
  [CODE_READER_QUESTION_SLUG]: 'Realize a leitura do código',
};

export function EditQuestion({ setEditing, data, fetchQuestion }) {
  const snackbar = useSnackbar();
 const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [questionType, setQuestionType] = useState(null);
  const [question, setQuestion] = useState({
    needAttachment: false,
    hasCorrectAnswer: false,
    fatherQuestion: null,
    hasSubQuestion: false,
    createOccurrence: false,
    active: true,
    answers: [],
    questionDescription: '',
    videoFile: null,
    mediaId: null,
    media: null,
  });

  const [childQuestion, setChildQuestion] = useState({
    hasSubQuestion: false,
    answers: [],
    active: true,
    questionDescription: '',
  });
  const [childQuestionType, setChildQuestionType] = useState(null);
  useEffect(() => {
    const normalizedSlug = (data?.type?.slug || '').toLowerCase();
    const isFixedQuestionType = [
      VEHICLE_PLATE_QUESTION_SLUG,
      IMPLEMENT_PLATE_QUESTION_SLUG,
      CODE_READER_QUESTION_SLUG,
    ].includes(normalizedSlug);
    const questionDescription = isFixedQuestionType
      ? FIXED_QUESTION_TEXT_BY_SLUG[normalizedSlug]
      : data?.question;
    setQuestion({
      id: data?.id,
      active: data?.active,
      needAttachment: data?.needAttachment,
      hasCorrectAnswer: data?.hasCorrectAnswer || false,
      createOccurrence: data?.createOccurrence,
      hasSubQuestion: !!data?.subQuestion,
      questionDescription,
      videoFile: null,
      mediaId: data?.mediaId || data?.media?.id || null,
      media: data?.media || null,
      occurrenceSector: data?.occurrenceGroup,
      answers: isFixedQuestionType
        ? []
        : data?.values?.map(item => {
            return {
              id: item?.id,
              order: item?.order,
              questionId: item?.questionId,
              description: item?.description,
              isCorrect: item?.isCorrect || false,
              triggerOccurrence:
                data?.questionOccurrenceValues?.filter(
                  sub => sub?.questionValueId === item?.id
                )?.length > 0,
              triggerSubQuestion:
                data?.subQuestion?.subValues?.filter(
                  sub => sub?.questionValueId === item?.id
                )?.length > 0,
            };
          }),
    });
    setQuestionType(data?.type);
    setChildQuestionType(data?.subQuestion?.type);
    setChildQuestion({
      active: data?.subQuestion?.active,
      createOccurrence: data?.subQuestion?.createOccurrence,
      questionDescription: data?.subQuestion?.question,
      occurrenceSector: data?.subQuestion?.occurrenceGroup,
      answers:
        data?.subQuestion?.values?.length > 0
          ? data?.subQuestion?.values?.map((item) => {
              return {
                id: item?.id,
                order: item?.order,
                questionId: item?.questionId,
                description: item?.description,
                triggerOccurrence:
                  data?.subQuestion?.questionOccurrenceValues?.filter(
                    (sub) => sub?.questionValueId === item?.id,
                  )?.length > 0,
              };
            })
          : [],
    });
  }, [data]);
  async function validate(data, setErrors) {
    setErrors({});
    const errorList = {};

    try {
      await QuestionSchema.validate(data, {
        abortEarly: false,
      });
      setErrors({ ...errorList });

      return { isValid: true, errorList };
    } catch (err) {

      if (Array.isArray(err?.inner) && err.inner.length > 0) {
        err.inner.forEach((error) => {
          errorList[error.path] = error.message;
        });
      } else if (err?.path) {
        errorList[err.path] = err.message;
      } else {
        errorList.form = err?.message || 'Revise os campos obrigatórios.';
      }

      setErrors({ ...errorList });

      return { isValid: false, errorList };
    }
  }
  async function handleEdit(data) {
    try {
      setLoading(true);
      const dataToValidate = {
        question: {
          ...data?.question,
          occurrenceSector: data?.question?.occurrenceSector?.id || null,
          occurrenceTrigger:
            data?.question?.createOccurrence &&
            data?.question?.answers?.filter((item) => item.triggerOccurrence)?.length > 0
              ? true
              : data?.question?.createOccurrence &&
                data?.question?.answers?.filter((item) => item.triggerOccurrence)?.length <= 0
              ? null
              : false,
          subQuestionTrigger:
            data?.question?.hasSubQuestion &&
            data?.question?.answers?.filter((item) => item.triggerSubQuestion)?.length > 0
              ? true
              : data?.question?.hasSubQuestion &&
                data?.question?.answers?.filter((item) => item.triggerSubQuestion)?.length <= 0
              ? null
              : false,
          typeSlug: data?.questionType?.slug,
          mediaId: data?.question?.mediaId,
          hasVideoFile: !!data?.question?.videoFile,
        },
        questionType: data?.questionType,
        childQuestion: {
          ...data?.childQuestion,
          occurrenceSector: data?.childQuestion?.occurrenceSector?.id || null,
          occurrenceTrigger:
            data?.childQuestion?.createOccurrence &&
            data?.childQuestion?.answers?.filter((item) => item.triggerOccurrence)?.length > 0
              ? true
              : data?.childQuestion?.createOccurrence &&
                data?.childQuestion?.answers?.filter((item) => item.triggerOccurrence)?.length <= 0
              ? null
              : false,
        },
        childQuestionType: data?.childQuestionType,
      };
      const validationResult = await validate(dataToValidate, setErrors);
      if (validationResult.isValid === false) {
        setLoading(false);
        const firstError =
          Object.values(validationResult.errorList || {})[0] ||
          'Revise os campos obrigatórios.';
        snackbar.show(<Text>{firstError}</Text>, { type: 'error' });
        return false;
      }

      let questionMediaId = data?.question?.mediaId || null;
      const isVideoVisualizationType =
        data?.questionType?.slug?.toLowerCase() ===
        VIDEO_VISUALIZATION_QUESTION_SLUG;

      if (
        isVideoVisualizationType &&
        data?.question?.videoFile instanceof File
      ) {
        const formData = new FormData();
        formData.append('file', data.question.videoFile);
        const uploadResponse = await cooperplaceApi.post(
          '/questions/video/upload',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        );
        questionMediaId = uploadResponse?.data?.media?.id || null;
      }
      const payload = {
        id: data?.question?.id,
        typeId: data?.questionType?.id,
        active: data?.question?.active,
        question: data?.question?.questionDescription,
        mediaId: questionMediaId,
        occurrenceSectorId: data?.question?.occurrenceSector?.id || null,
        needAttachment: data?.question?.needAttachment,
        hasCorrectAnswer: data?.question?.hasCorrectAnswer,
        values:
          data?.question?.answers?.length > 0
            ? data?.question?.answers?.map(item => {
                const { triggerSubQuestion, ...rest } = item;
                delete item.triggerSubQuestion;
                return { ...rest, subQuestion: triggerSubQuestion };
              })
            : [],
        subQuestion: data?.question?.hasSubQuestion
          ? {
              typeId: data?.childQuestionType?.id,
              question: data?.childQuestion?.questionDescription,
              occurrenceSectorId: data?.childQuestion?.occurrenceSector?.id || null,
              values:
                data?.childQuestion?.answers?.length > 0
                  ? data?.childQuestion?.answers?.map((item) => {
                      return { ...item };
                    })
                  : [],
            }
          : null,
      };
      await cooperplaceApi.put(`questions/${payload?.id}`, payload);
      snackbar.show(<Text>Pergunta atualizada com sucesso</Text>, {
        type: 'success',
      });
      await fetchQuestion(payload.id);
      setLoading(false);
      return true;
    } catch (error) {
      
      const backMsg =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        (Array.isArray(error?.response?.data?.messages)
          ? error.response.data.messages.join(' • ')
          : '');
      const message = backMsg || 'Erro ao tentar cadastrar pergunta.';
      snackbar.show(<Text>{message}</Text>, {
        type: 'error',
      });
      setLoading(false);
    }
  }

  async function handleEditQuestion() {
    const response = await handleEdit({
      question,
      questionType,
      childQuestion,
      childQuestionType,
    });
    if (response === false) {
      //
    } else setEditing(false);
  }

  return (
    <Card
      header={
        <Text color="dark" type="header">
          Dados da pergunta
        </Text>
      }
      HeaderRightComponent={
        <Space x="0.5rem">
          <Button variant="secondary" onClick={() => setEditing(false)} disabled={loading}>
            <Text>Cancelar</Text>
          </Button>

          <Button
            onClick={() => handleEditQuestion()}
            loading={loading}
            disabled={
              loading ||
              !canSaveVideoVisualizationQuestion(questionType, question)
            }
          >
            <Text>Salvar</Text>
          </Button>
        </Space>
      }
    >
      <RegisterComponent
        isRegister={false}
        question={question}
        setQuestion={setQuestion}
        questionType={questionType}
        setQuestionType={setQuestionType}
        childQuestion={childQuestion}
        setChildQuestion={setChildQuestion}
        childQuestionType={childQuestionType}
        setChildQuestionType={setChildQuestionType}
        errors={errors}
        setErrors={setErrors}
      />
    </Card>
  );
}
